module.exports = __webpack_public_path__ + "media/video1.b4e2b131.mp4";